export const capitalize = (value) =>
  value ? String(value).charAt(0).toUpperCase() + String(value).slice(1) : value;

export const groupTypeDotColor = (groupType) => {
  switch (String(groupType || '').toLowerCase()) {
    case 'system':
      return '#0f172a';
    case 'organization':
    case 'school':
      return '#2563eb';
    case 'team':
    case 'role':
      return '#0ea5e9';
    case 'period':
      return '#8b5cf6';
    case 'derived':
      return '#059669';
    default:
      return '#94a3b8';
  }
};

export const groupTypeLabel = (groupType) => {
  const t = String(groupType || '').toLowerCase();
  if (t === 'school') return 'Organization';
  if (t === 'role') return 'Team';
  if (t === 'period') return 'Period';
  if (t === 'derived') return 'Derived';
  if (t === 'system') return 'System';
  return capitalize(t || 'group');
};

/**
 * Client-facing type noun for a group.
 * When display_label is set (e.g. District, Program), use it in the type badge
 * instead of Organization / Team. group_type still drives color / hierarchy.
 */
export const resolveGroupDisplayLabel = (groupType, displayLabel) => {
  const custom = String(displayLabel || '').trim();
  if (custom) return custom;
  return groupTypeLabel(groupType);
};
